
import {
    AnimatePresence
} from "framer-motion";
import Navbar from "./components/navbar/Navbar";
import Footer from "./components/footer/Footer";
import Routes from "./Routes1";
import Loader from "./components/loader/Loader";
import BackgroundAnimation from "./components/background/BackgroundAnimation";
import {
    DataProvider,
    useData
} from "./config/DataContext";
import React, { useEffect } from "react";



const AppContent = () => {
    const {
        dataLoaded
    } = useData();

useEffect(() => {
  const script = document.createElement("script");
  script.src = "https://botbaseai.vercel.app/widget.js";
  script.async = true;
  script.setAttribute(
    "data-bot-id",
    "48f9e55b-0a19-4eb3-912a-7dc39168052e"
  );

  document.body.appendChild(script);
}, []);
    return ( < div className = "w-full min-h-screen bg-black text-white font-bodyFont overflow-x-hidden" > < AnimatePresence mode = "wait" > {
        !dataLoaded && < Loader key = "loader" / >
    } < /AnimatePresence> {dataLoaded && ( <> <BackgroundAnimation / > < Navbar / > < main className = "flex-grow relative z-10" > < Routes / > < /main> <Footer / > < /> )} </div > );
};

function App() {
    return ( < DataProvider > < AppContent / > < /DataProvider> ); } export default App;
